export const DESCRIPTION_PIN_KEY = "$description";

export const DESCRIPTION_CARD_OPT_OUT_KEY = "__description_card_opt_out";

export function shouldShowDescriptionOnCard(
  nodeConfig: Record<string, unknown> | undefined
): boolean {
  if (!nodeConfig?.__description) return false;
  return nodeConfig[DESCRIPTION_CARD_OPT_OUT_KEY] !== true;
}

export function isDescriptionPinnedToCard(
  nodeConfig: Record<string, unknown> | undefined
): boolean {
  return shouldShowDescriptionOnCard(nodeConfig);
}

export function withDescriptionCardPinned(
  nodeConfig: Record<string, unknown>
): Record<string, unknown> {
  const next = { ...nodeConfig };
  delete next[DESCRIPTION_CARD_OPT_OUT_KEY];
  return next;
}

export function withDescriptionCardUnpinned(
  nodeConfig: Record<string, unknown>
): Record<string, unknown> {
  return { ...nodeConfig, [DESCRIPTION_CARD_OPT_OUT_KEY]: true };
}
